import {
  Heading,
  minimumWidth,
  pxToRem,
  styled,
  textStyle,
  ThemeColors,
} from '@feast-it/ui/light';

export const Container = styled.div`
  ${({ theme }) => `
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacing[6]};

    ${minimumWidth(theme.breakpoints.small)} {
      flex-direction: row;
      gap: ${theme.spacing[4]};
    }
    ${minimumWidth(theme.breakpoints.large)} {
      gap: ${theme.spacing[10]};
    }
  `};
`;

export const ContentWrapper = styled.div`
  ${({ theme }) => `
    z-index: 4;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-grow: 1;
    width: 100%;

    ${minimumWidth(theme.breakpoints.small)} {
      min-width: ${pxToRem(320)};
      max-width: 62.5%;
    }
  `};
`;

export const MainContentWrapper = styled.div<{
  color: keyof ThemeColors;
}>`
  ${({ theme, color }) => `
    display: flex;
    flex-direction: column;
    color: ${theme.colors[color]};
    gap: ${theme.spacing[4]};

    ${minimumWidth(theme.breakpoints.small)} {
      gap: ${theme.spacing[8]};
    }
    ${minimumWidth(theme.breakpoints.large)} {
      gap: ${theme.spacing[6]};
    }
  `};
`;

export const StyledHeading = styled(Heading)`
  ${({ theme }) => `
    text-align: center;

    ${minimumWidth(theme.breakpoints.small)} {
      text-align: left;
    }
  `};
`;

export const BulletsDescWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    gap: ${pxToRem(10)};

    ${minimumWidth(theme.breakpoints.small)} {
      gap: ${theme.spacing[2]};
    };
  `};
`;

export const DescriptionWrapper = styled.div`
  ${({ theme }) => `
    ${textStyle(theme, 'bodyMedium')};
    text-align: center;

    ${minimumWidth(theme.breakpoints.small)} {
      ${textStyle(theme, 'headingExtraSmall')};
      text-align: left;
    };
  }
  `};
`;

export const ImageWrapper = styled.div`
  position: absolute;

  width: ${pxToRem(349)};
  height: ${pxToRem(291)};

  transform: rotate(2deg);

  ${({ theme }) => minimumWidth(theme.breakpoints.medium)} {
    width: ${pxToRem(420)};
    height: ${pxToRem(350)};
  }

  ${({ theme }) => minimumWidth(theme.breakpoints.extraLarge)} {
    width: ${pxToRem(750)};
    height: ${pxToRem(700)};
  }
`;

export const TogatherIconWrapper = styled.div`
  ${({ theme }) => `
    position: absolute;
    opacity: 30%;
    top: ${pxToRem(-150)};
    left: ${pxToRem(-117)};
    display: none;
    rotate: -10deg;

    ${minimumWidth(theme.breakpoints.extraLarge)} {
      display: block;
    }
  `}
`;

export const ReviewWrapper = styled.a`
  ${({ theme }) => `
    position: absolute;
    padding: ${theme.spacing[2]};
    border-radius: ${pxToRem(10)};
    top: 0;
    left: 0;
    right: 0;
    margin: 0 auto;

    z-index: 4;
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    width: fit-content;
    background: ${theme.colors.white};
    border: solid ${pxToRem(1)} ${theme.colors.black};

    ${minimumWidth(theme.breakpoints.small)} {
      top: unset;
      right: unset;
      bottom: 0;
      left: 0;
    }
    ${minimumWidth(theme.breakpoints.small)} {
      max-width: 180px;
    }
    ${minimumWidth(theme.breakpoints.large)} {
      max-width: unset;
    }
  `};
`;

export const RatingsLogoWrapper = styled.span`
  ${({ theme }) => `
    display: flex;
    align-items: center;
    gap: ${theme.spacing[1]};
  `}
`;

export const ReviewRatingsWrapper = styled.div`
  display: flex;
  justify-items: center;
  flex: 1;
`;

export const RatingText = styled.p`
  ${({ theme }) => `
    ${textStyle(theme, 'headingMedium')};

    ${minimumWidth(theme.breakpoints.small)} {
       ${textStyle(theme, 'headingLarge')};
    }
    ${minimumWidth(theme.breakpoints.large)} {
       ${textStyle(theme, 'headingExtraLarge')};
    }
  `};
`;

export const StarsWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    margin-left: ${theme.spacing[3]};

    ${minimumWidth(theme.breakpoints.small)} {
      flex-direction: row;
      gap: ${theme.spacing[2]};
      width: 100%;
      margin-left: unset;
    }
    ${minimumWidth(theme.breakpoints.large)} {
      flex-direction: column;
      gap: unset;
      border: unset;
      width: unset;
      margin-left: ${theme.spacing[3]};
    }
  `}
`;

export const ButtonWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing[4]};
    width: 100%;
    max-width: ${pxToRem(360)};
    margin: 0 auto;

    ${minimumWidth(theme.breakpoints.small)} {
      flex-direction: row;
      max-width: unset;
    }
  `};
`;
